import React, { useState } from 'react';
import CatSVG from '../utils/CatSVG';
import DogSVG from '../utils/DogSVG';
import PandaSVG from '../utils/PandaSVG';

const avatars = [
  { id: 1, name: "Gato", component: CatSVG },
  { id: 2, name: "Perro", component: DogSVG },
  { id: 3, name: "Panda", component: PandaSVG },
];

const RotationItem = ({ task, onTaskComplete, onTaskPostpone }) => {
  const [taskCompleted, setTaskCompleted] = useState(false);

  const handleTaskCompleted = () => {
    setTaskCompleted(true);
    onTaskComplete(task);
  };

  const handleTaskPostponed = () => {
    onTaskPostpone(task);
  };

  //const backgroundColor = lightenColor(participant.color, 40); 
  //const textColor = getTextColorForBackground(participant.color); 

  const { participant, location, day, postponements } = task;

  // Obtener el componente de avatar basado en el nombre
  const AvatarComponent = avatars.find(avatar => avatar.name === participant.avatar?.name)?.component;

  if (taskCompleted) {
    return null;
  };

  console.log(task);

  return (
    <div
      className="card relative p-3 rounded-xl shadow-md flex items-center justify-between"
     
    >
      <div className="flex items-center">
        <div className="mr-2">
        <AvatarComponent color={participant.color} />
        </div>
        <div>
          <h3 className="text-lg font-semibold">{participant.name}</h3>
          <div className="text-sm flex items-center">
            <span className="text-2xl">{location.icon}</span>
            <span className="ml-2">{location.name}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-end">
        <div className="text-xs text-gray-500">Día {day}</div>
        {postponements > 0 && (
          <div className="text-xs text-red-600 font-bold">
            Pospuesto {postponements} {postponements === 1 ? 'vez' : 'veces'}
          </div>
        )}
        <div className="flex flex-col mt-2">
          <button
            onClick={handleTaskCompleted}
            className="text-sm p-1 rounded-lg bg-green-500 text-white mx-1 hover:bg-green-600"
          >
            Completado
          </button>
          <button
            onClick={handleTaskPostponed}
            className="text-sm p-1 rounded-lg bg-yellow-500 text-white mx-1 hover:bg-yellow-600"
          >
            Posponer
          </button>
        </div>
      </div>
    </div>
  );
};

export default RotationItem;
